import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import {router} from "./router";

Vue.use(Vuex);

var Url = "https://api.mudu.com.tr/"; // TODO : CANLIDA
// var Url = "http://muhasip.mudu/";

const store = new Vuex.Store({
    state: {
        ju: JSON.parse(localStorage.getItem('_mudubo')),
        Proje: JSON.parse(localStorage.getItem('_muduboProje')),
        Proje_id: localStorage.getItem('_muduboProje_id'),
        ProjeAdi: localStorage.getItem('_muduboProjeAdi'),
    },
    mutations: {

        setToken(state, data) {
            if (data.ju) state.ju = data.ju
            if (data.Proje) state.Proje = data.Proje
            if (data.Proje_id) state.Proje_id = data.Proje_id
            if (data.ProjeAdi) state.ProjeAdi = data.ProjeAdi
        },

    },
    actions: {
        initAuth({commit, dispatch}) {
            let token = localStorage.getItem("_mudubo");
            if (!token) {
                if (location.pathname[1] + location.pathname[2] + location.pathname[3] + location.pathname[4] + location.pathname[5] != 'giris') {
                    router.push("/giris");
                    return false
                }
            }
        },
        Post({commit, dispatch, state}, data) {
            let BaseUrl = null;

            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;

            return axios.post(
                BaseUrl,
                {...data},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.ju ? 'Bearer ' + state.ju.token : '',
                        'proje': state.Proje_id
                    }
                }
            ).then(response => {
                return response.data;
            })
        },
        Put({commit, dispatch, state}, data) {
            let BaseUrl = null;

            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;

            return axios.put(
                BaseUrl,
                {...data},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.ju ? 'Bearer ' + state.ju.token : '',
                        'proje': state.Proje_id
                    }
                }
            ).then(response => {
                return response.data;
            })
        },
        Get({commit, dispatch, state}, data) {
            let BaseUrl = null;
            $("body").addClass('yukleniyor')
            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;


            if (data.loading != false) data.loading = true;
            return axios.get(
                BaseUrl,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.ju ? 'Bearer ' + state.ju.token : '',
                        'proje': state.Proje_id
                    }
                }
            ).then(
                response => {

                    if (response.data.Status === 401) {
                        this.dispatch("logout");
                    } else {
                        $("body").removeClass('yukleniyor')
                    }
                    return response.data;

                },
                error => {
                });
        },
        Delete({commit, dispatch, state}, data) {
            let BaseUrl = null;

            if (!data.Url)
                BaseUrl = Url + data.path;
            else
                BaseUrl = data.Url + data.path;

            return axios.delete(
                BaseUrl,
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Cache-Control': 'no-cache',
                        'Authorization': state.ju ? 'Bearer ' + state.ju.token : '',
                        'proje': state.Proje_id
                    }
                }
            ).then(response => {
                return response.data;
            });
        },
        logout({commit}) {
            // commit("clearToken");
            localStorage.clear();
            location.reload();
        },
        title({commit}, data) {
            document.title = "M | " + data
        },
        session({commit, dispatch, state}, data) {
            commit('setToken', data)
        }

    },
    getters: {
        isOturum(state) {
            return !!state.ju;
        },
    },

});

export default store



// WEBPACK FOOTER //
// ./src/store.js